import { render, staticRenderFns } from "./expressConfig.vue?vue&type=template&id=38fe26ac&scoped=true&"
import script from "./expressConfig.vue?vue&type=script&lang=js&"
export * from "./expressConfig.vue?vue&type=script&lang=js&"
import style0 from "./expressConfig.vue?vue&type=style&index=0&id=38fe26ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fe26ac",
  null
  
)

export default component.exports